<template>
  <div class="tabs-component" :style="{ height }">
    <div v-for="(tab, tabIndex) in tabList">
      <div
        class="tab-item"
        :class="{ selected: index === tabIndex }"
        @click="select(tabIndex)"
      >
        <div v-if="tab.icon" class="tab-icon" :class="tab.icon"></div>
        <div>{{ tab.title }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.tabs-component {
  width: 100%;
  display: flex;
  justify-content: space-around;
  .tab-item {
    font-size: 14px;
    height: 100%;
    color: @font-color-gray;
    cursor: pointer;
    display: flex;
    align-items: center;
    box-sizing: padding-box;
    border-bottom: 3px solid transparent;
    &.selected {
      color: black;
      border-bottom-color: black;
      .tab-icon {
        &.media {
          background-image: url("../../../../public/images/library/S_Media@3x.png");
        }
        &.saved {
          background-image: url("../../../../public/images/library/S_Saved@3x.png");
        }
      }
    }
    .tab-icon {
      width: 25px;
      height: 25px;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-right: 5px;
      &.media {
        background-image: url("../../../../public/images/library/M_Media@3x.png");
      }
      &.saved {
        background-image: url("../../../../public/images/library/M_Saved@3x.png");
      }
    }
  }
}
</style>

<script>
export default {
  name: "TabsComponent",
  model: {
    prop: "value",
    event: "updateValue",
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    height: {
      type: String,
      default: "40px",
    },
    tabList: {
      type: Array,
      default: () => {
        return [{ title: "History" }, { title: "Saved & Hashtag" }];
      },
    },
  },
  methods: {
    select(index) {
      this.index = index;
    },
  },
  data() {
    return {
      tabInfo: [],
      index: this.value,
    };
  },
  mounted() {
    this.tabInfo = this.$children.map((p) => {
      return {
        title: p.title,
      };
    });
  },
  watch: {
    index(val) {
      this.$emit("updateValue", val);
    },
    value(val) {
      this.index = val;
    },
  },
};
</script>
